module.exports = "/assets/data/15b88af8f223d51be48ebede89c3f9ba-AB55.data.json";